<template>
    <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                    <div class="col-8">
                        <h3 class="mb-0">{{ ($router.currentRoute.name === 'protocols_edit') ? 'Protokoll' : 'Neues Protokoll'}}</h3>
                    </div>
                    <div v-if="$router.currentRoute.name === 'protocols_edit'" class="col text-right">
                        <base-button  type="primary" size="sm" v-on:click="$router.push('/service/protocols')">zurück</base-button>
                    </div>
                    <div v-else class="col text-right">
                        <base-button v-show="showSelectForm !== null && answers.length === 0" type="primary" size="sm" v-on:click="setSelectForm(null)">zurück</base-button>
                        <base-button v-show="showSelectForm !== null && answers.length > 0" type="primary" size="sm" v-on:click="setValuesToDefault">neues Protokoll</base-button>
                    </div>
                </div>
            </div>
            <div v-show="showSelectForm === null">
                <!--- wenn v-show; dann wird select nicht ausgeblendet; wenn v-if dann reference error --->
                <SelectForm ref="selectform" :location="($router.currentRoute.name === 'protocols_edit') ? location : $store.getters['authentication/location']"/>
            </div>
            <template>
                <form v-show="showSelectForm !== null" @submit.prevent="createProtocol">
                    <!--- Status oben entfernt:  <base-alert v-if="status.type !== ''" :type="status.type">{{ status.msg }}</base-alert> --->
                    <h6 class="heading-small text-muted mb-4">Angaben zum Protokoll</h6>
                    <Protocolform :status="status" :admin="false" ref="PForm"></Protocolform>
                    <button v-if="status.type !== 'success'" class="btn btn-icon my-4 btn-primary" :disabled="isLoading">
                        <span :key="tick+'b1'" class="btn-inner--icon"><i v-if="isLoading" class="fas fa-circle-notch fa-spin"></i><i v-else class="ni ni-fat-add"></i></span>
                        <span class="btn-inner--text">Protokoll {{formButtonText}}</span></button>
                </form>
                <div v-if="showQuestions">
                    <hr class="my-4" />
                    <base-alert v-if="status.type !== ''" :type="status.type">{{ status.msg }}</base-alert>
                    <h6 class="heading-small text-muted mb-4">Fragen und mögliche Antworten</h6>
                    <div v-for="(question,index) in $refs.selectform.forms[showSelectForm].questions" :key="index">
                        <form v-if="answers[index]" @submit.prevent="createAnswer(index,question)" :key="index+tick*1000" style="width: 100%;">
                            <div class="row align-items-center">
                            <QuestionsAndAnswers :ref="'QA'+index" :answers="answers" :index="index" :question="question"/>
                            <div v-if="answers[index].edit" class="col-2">
                                <button class="btn btn-icon my-4 btn-primary" :disabled="isLoading">
                                    <span :key="tick+'b2'" class="btn-inner--icon"><i v-if="isLoading" class="fas fa-circle-notch fa-spin"></i><i v-else class="fas fa-save"></i></span>
                                </button>
                                <base-button v-if="(answers[index].id)" type="primary" icon="far fa-window-close" v-on:click="enableAnswerForm(index)"></base-button>
                            </div>
                            <div  v-else class="col-lg-2">
                                    <base-button v-if="!isNoAdminAndEdit" type="primary" icon="ni ni-settings-gear-65" v-on:click="enableAnswerForm(index)"></base-button>
                                    <!---<base-button v-if="!answers[index].delete" type="primary" icon="far fa-trash-alt" v-on:click="deleteConfirmation(index)"></base-button>
                                    <div v-if="answers[index].delete" style="margin-top: 1rem;"><span  class="text-danger">Sicher? <i class="fas fa-trash-alt"></i></span><br>
                                        <base-button v-if="answers[index].delete" size="sm" type="danger" icon="fas fa-check" v-on:click="deleteAnswer(index)">Ja</base-button>
                                        <base-button v-if="answers[index].delete" size="sm" type="info" icon="fas fa-times" v-on:click="deleteConfirmation(index)">Nein</base-button>
                                    </div>--->

                            </div>
                        </div>
                        </form>
                    </div>
                    <base-button v-if="nextQuestion && $router.currentRoute.name === 'protocols_edit' && !finished && computedAllAnswersSaved" type="primary" icon="fa fa-arrow-right" v-on:click="newQuestion">weiter</base-button>
                    <!--- könnte zu Fehler in Reihenfolge der Antworten führen: <base-button v-if="!finished && !isNoAdminAndEdit" :key="(tick+26)*10" type="primary" :disabled="isLoading"  v-on:click="saveAllAnswers"><span class="btn-inner--icon"><i v-if="isLoading" class="fas fa-circle-notch fa-spin"></i><i v-else class="far fa-save"></i></span> alle Antworten speichern</base-button>--->
                    <base-alert v-if="finished" :key="tick*100" type="success">Sehr gut! Alle Antworten wurden gespeichert!</base-alert>
                    <div v-if="$router.currentRoute.name === 'protocols_edit'" class="col pt-5 text-left">
                        <base-button  type="primary" size="sm" v-on:click="$router.push('/service/protocols')">zurück</base-button>
                    </div>
                    <div v-else class="col pt-5 text-left">
                        <base-button v-show="finished" type="primary" size="sm" v-on:click="setValuesToDefault">neues Protokoll</base-button>
                    </div>
                </div>
            </template>
    </card>
</template>

<script>


    import Protocolform from "@/views/Protocols/Protocolform";
    import SelectForm from "@/views/Protocols/SelectForm";
    import QuestionsAndAnswers from "@/views/Protocols/QuestionsAndAnswers";

    export default {
        name: "protocol-create",
        components: {QuestionsAndAnswers, SelectForm, Protocolform},
        data() {
            return {
                defaultA:{
                    answer: [],
                    extra: '',
                    edit: true,
                    delete: false
                },
                isMounted: false,
                isLoading: false,
                tick: 1,
                answers: [],
                status: {
                    type: '',
                    msg: ''
                },
                location: ''

            }
        },
        created(){
        },
        mounted(){
            this.isMounted = true;
            this.isLoading = true;
            this.tick++;
            this.$refs.selectform.getForms().then(response => {
                    this.$refs.selectform.forms = [];
                    response.member.forEach(item => {
                        this.$refs.selectform.forms.push(item.form) ;
                    });
                    if (this.$router.currentRoute.name === "protocols_edit") {
                        this.getProtocolAndFormData(this.$route.params.id).then(response => {
                                this.answers = response.answers;
                                this.answers.forEach(a => {
                                    a.edit = false;
                                    a.delete = false;
                                });

                                let value = this.$refs.selectform.forms.findIndex(x => x.id === response.form.id);
                                if (value < 0) {
                                    this.$refs.selectform.forms[0] = response.form;
                                     value = 0;
                                }

                                this.setSelectForm(value);

                                this.$refs.PForm.form = response;
                                this.$refs.PForm.form.location = response.location['@id'];
                                this.location = response.location['id'];

                                this.isLoading = false;
                                this.tick++;
                            },
                            error => {
                                this.isLoading = false;
                                this.tick++;
                                this.status =  {type: 'danger', msg: error};
                            });

                    } else {
                        this.isLoading = false;
                        this.tick++;
                    }
                },
                error=> {
                    this.status =  {type: 'danger', msg: error};
                    this.isLoading = false;
                    this.tick++;
                });
        },
        computed: {
            showQuestions() {
                return (this.isMounted && this.$refs.selectform.selectedForm !== null) ? (this.$refs.PForm.form.id) : false;
            },
            formButtonText() {
                return (this.$router.currentRoute.name === "protocols_edit") ? 'editieren' : 'anlegen';
            },
            finished() {
                return (this.isMounted && this.$refs.selectform.selectedForm !== null) ? this.allQuestionsAnswered(this.answers,this.$refs.selectform.forms[this.$refs.selectform.selectedForm].questions) && this.allAnswersSaved(this.answers,this.tick) : false;
            },
            nextQuestion() {
                return (this.isMounted && this.$refs.selectform.selectedForm !== null) ? !this.allQuestionsAnswered(this.answers,this.$refs.selectform.forms[this.$refs.selectform.selectedForm].questions) : false;
            },
            showSelectForm() {
                return (this.isMounted) ? this.$refs.selectform.selectedForm : null;
            },
            isNoAdminAndEdit() {
                return !this.$store.getters['authentication/isAdmin'] && (this.$router.currentRoute.name === "protocols_edit");
            },
            computedAllAnswersSaved() {
                return this.allAnswersSaved(this.answers,this.tick);
            }
        },
        methods: {
            setSelectForm(value) {
                this.$refs.selectform.selectedForm=value;
            },
            setValuesToDefault() {
                this.$refs.selectform.selectedForm=null;
                this.answers = [];
                this.$refs.PForm.form =  {
                    reference: '',
                    comment: '',
                    profile: null,
                    form: null
                };
                this.status= {
                    type: '',
                    msg: ''
                };
                this.tick++;

            },
            allAnswersSaved(answers,tick) {
              let status = true;

              answers.forEach(answer =>{
                  if((!answer.id || answer.edit) && tick >= 0)  status = false;
              });
                return status;
            },
            allQuestionsAnswered(answers,questions) {
                return questions.length === answers.length
            },
            enableAnswerForm(index) {
                this.answers[index].edit = !this.answers[index].edit;
                this.tick++;
                this.$forceUpdate();

            },
            deleteConfirmation(index) {
                this.answers[index].delete = !this.answers[index].delete;
                this.tick++;

            },
            getProtocolAndFormData(id){
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header,
                    };
                    this.isLoading = true;
                    fetch(process.env.VUE_APP_API_SERVER + `/api/protocols/`+id, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                resolve(response)
                            },
                            error => {
                                reject(error)
                            });
                });
            },
            createProtocol() {
                return new Promise((resolve, reject) => {
                    if (this.$refs.PForm.form.reference !== '') {
                            this.isLoading = true;
                        this.tick++;
                        const header = this.authHeader();
                        header['Content-Type'] = (!this.$refs.PForm.form.id) ? 'application/json' : 'application/merge-patch+json';
                        let senddata = this.$refs.PForm.form;
                        senddata.profile = this.$store.getters['profiles/showActiveProfile']['@id'];
                        senddata.form = this.$refs.selectform.forms[this.$refs.selectform.selectedForm]['@id'];
                        //senddata.location = '/api/locations/'+this.$store.getters['authentication/location'];
                        const requestOptions = {
                            method:(!this.$refs.PForm.form.id) ? 'POST' : 'PATCH',
                            headers:header,
                            body:JSON.stringify(senddata)
                        };
                        let string = (!this.$refs.PForm.form.id) ? 'erstellt' : 'geändert';
                        let url = (!this.$refs.PForm.form.id) ? '/api/protocols' : '/api/protocols/' + this.$refs.PForm.form.id;
                        fetch(process.env.VUE_APP_API_SERVER + url, requestOptions)
                            .then(this.handleResponse)
                            .then(response => {
                                    this.isLoading = false;
                                    this.tick++;
                                    this.$refs.PForm.form = response;
                                    this.$refs.PForm.form.location = response.location['@id'];
                                    if (string === "erstellt") this.answers.push(this.cloneDefaultAnswer());
                                    this.status = {
                                        type:'success',
                                        msg:'Das Protokoll (ID: ' + response.id + ') wurde ' + string + '.'
                                    };
                                    resolve(response);
                                },
                                error => {
                                    this.isLoading = false;
                                    this.tick++;
                                    this.status = {type:'danger', msg:error};
                                    reject(error);
                                });
                    } else {
                        this.tick++;
                        let msg = 'Bitte unter "Referenz" einen anonymisierten Namen für den Spielgast eingeben.';
                        this.$store.dispatch('alert/warn',msg);
                        reject(msg);
                    }
                });
            },
            deleteAnswer(index) {
                return new Promise((resolve, reject) => {
                        this.isLoading = true;
                        const header = this.authHeader();
                        header['Content-Type'] = 'application/merge-patch+json';
                        let senddata = this.answers[index]['@id'];
                        const requestOptions = {
                            method: 'DELETE',
                            headers: header,
                            body: JSON.stringify(senddata)
                        };
                        if (!this.answers[index].id) {
                            this.answers.splice(index,1);
                            this.isLoading = false;
                            resolve(true);
                        } else {
                            let url = '/api/answers/' + this.answers[index].id;
                            fetch(process.env.VUE_APP_API_SERVER + url, requestOptions)
                                .then(this.handleResponse)
                                .then(response => {
                                        this.isLoading = false;
                                        this.answers.splice(index,1);
                                        this.status =  {type: 'success', msg: 'Der Frage (ID: '+response.id+') wurde gelöscht.'};
                                        resolve(response);
                                    },
                                    error => {
                                        this.isLoading = false;
                                        this.status =  {type: 'danger', msg: error};
                                        reject(error);
                                    });
                        }
                });
            },
            createAnswer(index,question) {
                return new Promise((resolve, reject) => {
                    if (!this.$refs.PForm.form.id) {
                        let error = 'Bitte zunächst Protokoll anlegen';
                        this.status =  {type: 'danger', msg: error};
                        reject(error)
                    } else {
                        this.isLoading = true;
                        this.tick++;
                        const header = this.authHeader();
                        header['Content-Type'] = (!this.answers[index].id) ? 'application/json' : 'application/merge-patch+json';
                        let senddata = this.answers[index];
                        senddata.protocol = this.$refs.PForm.form['@id'];
                        senddata.question = question['@id'];
                        const requestOptions = {
                            method: (!this.answers[index].id) ? 'POST' : 'PATCH',
                            headers: header,
                            body: JSON.stringify(senddata)
                        };
                        let string = (!this.answers[index].id) ? 'erstellt' : 'geändert';
                        let url = (!this.answers[index].id) ? '/api/answers' : '/api/answers/' + this.answers[index].id;
                        fetch(process.env.VUE_APP_API_SERVER + url, requestOptions)
                            .then(this.handleResponse)
                            .then(response => {
                                    this.isLoading = false;
                                    this.tick++;
                                    this.answers[index] = response;
                                    this.answers[index].edit = false;
                                    this.answers[index].delete = false;
                                    this.tick++;
                                    this.$forceUpdate();
                                    this.status = {
                                        type: 'success',
                                        msg: 'Die Antwort (ID: ' + response.id + ') wurde ' + string + '.'
                                    };



                                    if (!this.allQuestionsAnswered(this.answers,this.$refs.selectform.forms[this.$refs.selectform.selectedForm].questions)) {
                                        //let next = index +1;
                                        if(string === "erstellt") this.answers.push(this.cloneDefaultAnswer());


                                        // todo dynamsche referenz funktioniert nicht
                                        /*
                                        this.$nextTick(()=>{
                                            // eslint-disable-next-line no-console
                                            console.log(this.$refs['QA'+next][0].$refs);
                                            // eslint-disable-next-line no-console
                                            console.log(this.$refs['QA'+next][0].$refs['a'+next]);
                                            if (!Array.isArray(this.$refs['QA'+next][0].$refs['a'+next])) {
                                                this.$refs['QA'+next][0].$refs['a'+next].$el.focus();
                                            } else {
                                                this.$refs['QA'+next][0].$refs['a'+next][0].$el.focus();
                                            }
                                        }) */
                                    }
                                    resolve(response);
                                },
                                error => {
                                    this.isLoading = false;
                                    this.tick++;
                                    this.status = {type: 'danger', msg: error};
                                    reject(error);
                                });
                    }
                    });
                },
            saveAllAnswers() {
                this.answers.forEach((a,i)=>{
                    this.createAnswer(i,this.$refs.selectform.forms[this.$refs.selectform.selectedForm].questions[i])});
            },
            cloneDefaultAnswer(){
                return JSON.parse(JSON.stringify(this.defaultA))
            },
            newQuestion() {
                this.answers.push(this.defaultA);
                this.tick++;
            }
        }
    }
</script>

